/* eslint-disable react-hooks/exhaustive-deps */
import _ from "lodash";
import React, { useEffect, useState } from "react";
import classHandler from "classnames";
import { productHelper, svgIcon, formatPrice } from "../Functions";
import { toast } from "react-toastify";
import productPlaceholder from "../Assets/images/product_placeholder.png";
import CreatableSelect from "react-select/creatable";
import { APP_DOMAIN } from "../config";
import { useContext } from "react";
import { GlobalSearchContext } from "../Components/Viewer/context";
import SpinnerLoader from "../Common/SpinnerLoader";
import DOMPurify from "dompurify";
import Service from "../Action/service";
import ModalHeader from "../Common/ModalHeader";

const stripHtml = (html) => {
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
};
const RemoveIcon = APP_DOMAIN + "/images/remove.svg";
const AddIcon = APP_DOMAIN + "/images/add.svg";

const tableHeader = [
  {
    name: "_img",
    text: "Image",
  },

  {
    name: "product_name",
    text: "Product Name",
  },
  {
    name: "tag_name",
    text: "Tag",
  },
  {
    name: "sku_code",
    text: "Sku Code",
  },

  {
    name: "_desc",
    text: "Product Description",
  },

  {
    name: "qty",
    text: "Qty.",
  },

  {
    name: "price",
    text: "Price",
  },

  // {
  //     name: 'delete',
  //     text: ' ',
  // }
];

const colourStyles = {
  option: (styles, { isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "transparent" : null,
      color: "#000",
    };
  },
};

const ProductDrawer = ({
  isOpen,
  cartCounterHandler,
  closeCart,
  togglePopup,
  pdf,
  isSidebar
}) => {
  const [cardloading, setcardloading] = useState(false);
  const [cartData, setCartData] = React.useState([]);
  const [PRODUCT, setProduct] = React.useState({});
  const [readMore, setReadMore] = useState({});
  // const [tagOptions, setTagOptions] = useState([]);
  const [isClearConfirmationModalOpen, setIsClearConfirmationModalOpen] =
    useState(false);
  const [isExcel] = useState(localStorage.getItem("isExcel"));
  const [priceValue] = useState(localStorage.getItem("priceValue") || "Price");
  const [belowTotalMrp] = useState(localStorage.getItem("belowTotalMrp") || "");
  const { tagOptions, createTag } = useContext(GlobalSearchContext);
  const [expandedMandatory, setExpandedMandatory] = useState({});

  const toggleMandatoryAccordion = (sku) => {
    setExpandedMandatory((prev) => ({
      ...prev,
      [sku]: !prev[sku],
    }));
  };

  const handleReadMore = (id) => {
    setReadMore({
      ...readMore,
      [id]: !readMore[id],
    });
  };

  useEffect(() => {
    if (pdf?.excel !== undefined) {
      localStorage.setItem("isExcel", pdf?.excel);
    }
  }, [pdf, isExcel]);

  // const createTag = (tag, index) => {
  //     setTagOptions(prevState => [...prevState, { label: tag, value: '' }])
  // }
  const handleTagChange = (tag, index) => {
    setcardloading(true);
    let newCartItem = [...cartData];
    newCartItem[index].tag = tag["label"];
    setCartData(newCartItem);
    // setcardloading(false);
    setcardloading(false);
  };

  const fetchCartData = async () => {
    try {
      setcardloading(true);

      const { data, error } = await PRODUCT.CartData();

      if (error) {
        setcardloading(false);
        return;
      }

      const Parent = [];
      const Children = [];

      // Separate parent & mandatory products
      data.forEach((item) => {
        if (item.isMandatory) {
          Children.push(item);
        } else {
          Parent.push({
            ...item,
            MandatoryProducts: [],
          });
        }
      });

      // Attach mandatory products to parent
      Children.forEach((c) => {
        const FindParent = Parent.find(
          (p) => p.product_id === c.parentID
        );

        if (FindParent) {
          FindParent.MandatoryProducts.push(c);
        }
      });
      setCartData(Parent);

    } catch (err) {
      console.error(err);
    } finally {
      setcardloading(false);
    }
  };

  const onQuantityUpdate = async (
    qty,
    sku_code,
    product_name,
    isMandatory,
    ParentId
  ) => {
    try {
      setcardloading(true);

      // Find parent product
      const parentProduct = cartData.find(
        (p) => p.sku_code === sku_code
      );

      if (!parentProduct) {
        setcardloading(false);
        return;
      }

      // DELETE FLOW
      if (qty < 1) {

        // Delete mandatory products first
        if (parentProduct?.MandatoryProducts?.length > 0) {
          await Promise.all(
            parentProduct.MandatoryProducts.map((m) =>
              events.handleDelete(
                m.sku_code,
                m.product_name || m.name,
                true,
                parentProduct.product_id
              )
            )
          );
        }

        // Delete parent product
        await events.handleDelete(
          sku_code,
          product_name,
          false
        );

        return;
      }

      // Fetch mandatory products config
      let mandatoryProducts = [];

      const resMandatory = await Service.get(
        `public/getmandatorypublicproducts/${parentProduct.product_id}`
      ).catch((error) => {
        console.error(error);
        return null;
      });

      mandatoryProducts =
        resMandatory?.data?.data || [];

      // LOCAL UI UPDATE
      const updatedCart = cartData.map((item) => {

        if (item.sku_code === sku_code) {

          return {
            ...item,
            quantity: qty,

            MandatoryProducts:
              item.MandatoryProducts?.map((m) => {

                const mandatoryConfig =
                  mandatoryProducts.find(
                    (mp) =>
                      mp.sku_code === m.sku_code
                  );

                const baseQty =
                  mandatoryConfig?.quantity || 1;

                return {
                  ...m,
                  baseQty,
                  quantity: baseQty * qty,
                };
              }) || [],
          };
        }

        return item;
      });

      setCartData(updatedCart);

      // UPDATE PARENT API
      await PRODUCT.UpdateQuantity(
        sku_code,
        qty
      );

      // UPDATE MANDATORY PRODUCTS API
      const updatedParent = updatedCart.find(
        (p) => p.sku_code === sku_code
      );

      if (
        updatedParent?.MandatoryProducts?.length > 0
      ) {

        await Promise.all(
          updatedParent.MandatoryProducts.map((m) =>
            PRODUCT.UpdateQuantity(
              m.sku_code,
              m.quantity,
              true,
              updatedParent.product_id
            )
          )
        );
      }

    } catch (error) {
      console.error(error);
    } finally {
      setcardloading(false);
    }
  };

  const onProductDelete = async (sku_code, name, isMandatory, ParentId) => {
    try {
      const res = await PRODUCT.DeleteCartItem(sku_code, isMandatory, ParentId);
      const error = res.data.error;

      if (error) {
        toast.success("something went wrong!", {
          className: "toast-style",
        });
      } else {
        toast.success(name + " successfully deleted!", {
          className: "toast-style",
        });

        cartCounterHandler.fetchCartCounterData();
      }
    } catch (error) {
      toast.success("something went wrong!", {
        className: "toast-style",
      });
    }

    fetchCartData();
  };

  React.useEffect(() => {
    setProduct(new productHelper(null));
  }, []);

  React.useEffect(() => {
    if (Object.keys(PRODUCT).length <= 0) return;
    fetchCartData();
  }, [isOpen]);

  const containerClass = classHandler({
    "product-drawer": true,
    "is-open": isOpen,
    "Sidenav-product-drawer": isSidebar
  });

  const events = {
    handleQuantity: onQuantityUpdate,
    handleDelete: onProductDelete,
  };

  const enablePopup = (type, data = {}) => {
    let popupConfig = {
      isActive: true,
      data,
      type,
    };

    togglePopup(popupConfig);
  };

  const printHanler = async () => {
    if (cartData[0]?.isTag) {
      let producWithTag = cartData?.map((data) => {
        return { sku_code: data?.sku_code, tag: data?.tag ? data?.tag : "" };
      });
      let _result = await PRODUCT.addtagtoProducts(producWithTag);
      if (_result.status === 200) {
        let pdfUrl = await PRODUCT.PrintCart();
        const data = {
          url: pdfUrl.data,
          clientID: pdf.clientID,
        };

        const popupConfig = {
          isActive: true,
          data,
          type: "cartDownload",
          closeCart: closeCart,
        };

        if (cartData[0].leadForm) {
          if (cartData[0].isformBuilder && cartData[0].formID && cartData[0].formID !== "") {
            enablePopup("cartDownloadCustomForm", {
              ...popupConfig,
              formID: cartData[0].formID
            });
          } else {
            enablePopup("cartDownload", popupConfig);
          }
        } else {
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(pdfUrl.data);
          // Give filename you wish to download
          a.download = "cart.pdf";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          toast.success("successfully download!", {
            className: "toast-style",
          });
        }
      }
    } else {
      let pdfUrl = await PRODUCT.PrintCart();

      const data = {
        url: pdfUrl.data,
        clientID: pdf.clientID,
      };

      const popupConfig = {
        isActive: true,
        data,
        type: "cartDownload",
        closeCart: closeCart,
      };

      if (cartData[0].leadForm) {

        if (cartData[0].isformBuilder && cartData[0].formID && cartData[0].formID !== "") {
          enablePopup("cartDownloadCustomForm", {
            ...popupConfig,
            formID: cartData[0].formID
          });
        } else {
          enablePopup("cartDownload", popupConfig);
        }

      } else {
        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(pdfUrl.data);
        // Give filename you wish to download
        a.download = "cart.pdf";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        toast.success("successfully download!", {
          className: "toast-style",
        });
      }
    }
  };
  const printExcelHanler = async () => {
    if (cartData[0]?.isTag) {
      let producWithTag = cartData?.map((data) => {
        return { sku_code: data?.sku_code, tag: data?.tag ? data?.tag : "" };
      });
      let _result = await PRODUCT.addtagtoProducts(producWithTag);
      if (_result.status === 200) {
        let pdfUrl = await PRODUCT.PrintExcelCart();
        let fileName = pdfUrl?.headers["content-disposition"]?.split("=");
        const data = {
          url: pdfUrl.data,
          clientID: pdf.clientID,
        };

        const popupConfig = {
          isActive: true,
          data,
          type: "cartDownload",
          closeCart: closeCart,
        };
        if (cartData[0].leadForm) {
          if (cartData[0].isformBuilder && cartData[0].formID && cartData[0].formID !== "") {
            enablePopup("cartDownloadCustomForm", {
              ...popupConfig,
              formID: cartData[0].formID
            });
          } else {
            enablePopup("cartDownload", popupConfig);
          }
        } else {
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(pdfUrl.data);
          a.download = `${fileName[1]}`;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          toast.success("successfully download!", {
            className: "toast-style",
          });
        }
      }
    } else {
      let pdfUrl = await PRODUCT.PrintExcelCart();
      let fileName = pdfUrl?.headers["content-disposition"]?.split("=");
      const data = {
        url: pdfUrl.data,
        clientID: pdf.clientID,
      };

      const popupConfig = {
        isActive: true,
        data,
        type: "cartDownload",
        closeCart: closeCart,
      };
      if (cartData[0].leadForm) {
        if (cartData[0].isformBuilder && cartData[0].formID && cartData[0].formID !== "") {
          enablePopup("cartDownloadCustomForm", {
            ...popupConfig,
            formID: cartData[0].formID
          });
        } else {
          enablePopup("cartDownload", popupConfig);
        }
      } else {
        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(pdfUrl.data);
        // Give filename you wish to download
        // a.download = "cart.pdf";
        a.download = `${fileName[1]}`;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        toast.success("successfully download!", {
          className: "toast-style",
        });
      }
    }
  };

  const handleOpenConfirm = () => {
    setIsClearConfirmationModalOpen(!isClearConfirmationModalOpen);
  };
  const CloseConfirmModal = () => {
    setIsClearConfirmationModalOpen(false);
  };

  const handleClearCart = async () => {
    try {
      await PRODUCT.ClearCartItem();
      cartCounterHandler.fetchCartCounterData();
      fetchCartData();
      setIsClearConfirmationModalOpen(false);
    } catch (error) {
      toast.success("something went wrong!", {
        className: "toast-style",
      });
    }
  };

  return (
    <React.Fragment key="5">
      <div className={containerClass} onClick={(e) => e.stopPropagation()}>
        <ModalHeader title="Your Cart" onClose={closeCart} />

        {cardloading ? (
          <p className="empty-cart-text">
            <SpinnerLoader />
          </p>
        ) : (
          <>
            {cartData && cartData.length > 0 ? (
              <React.Fragment>
                {/* Unified Figma cart layout (desktop + mobile) */}
                <div className="cartCardsList">
                  {cartData.map((item, _index) => {
                    const parentDesc = stripHtml(item?.product_description) || "";
                    const isParentDescLong = parentDesc.length > 50;
                    const isParentExpanded = !!readMore[item?.sku_code];
                    return (
                      <React.Fragment key={`card-${_index}`}>
                        <div className="cartProductCardContainer">

                          <div className="cartProductCard">
                            <div className="cartProductImage">
                              <img
                                src={item?.product_image || productPlaceholder}
                                onError={(e) => {
                                  e.target.src = productPlaceholder;
                                }}
                                alt={item?.product_name || "..."}
                              />
                            </div>
                            <div className="cartProductInfo">
                              <h4 className="cartProductName">
                                {item?.product_name}
                              </h4>
                              <p className="cartProductSku">{item?.sku_code}</p>
                              {parentDesc && (
                                <p className="cartProductDesc">
                                  {isParentDescLong && !isParentExpanded ? (
                                    <>
                                      {`${parentDesc.slice(0, 50)}... `}
                                      <b
                                        className="cursorPointer cartReadMore"
                                        onClick={() =>
                                          handleReadMore(item?.sku_code)
                                        }
                                      >
                                        Read more
                                      </b>
                                    </>
                                  ) : isParentDescLong ? (
                                    <>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: DOMPurify.sanitize(
                                            item?.product_description
                                          ),
                                        }}
                                      />
                                      <b
                                        className="cursorPointer cartReadMore"
                                        onClick={() =>
                                          handleReadMore(item?.sku_code)
                                        }
                                      >
                                        {" "}Read less
                                      </b>
                                    </>
                                  ) : (
                                    parentDesc
                                  )}
                                </p>
                              )}
                              <p className="cartProductPrice">
                                &#8377;{formatPrice((item?.quantity || 0) * (item?.product_price || 0))}
                                {priceValue && priceValue !== "Price" && (
                                  <span className="cartPriceLabel"> ({priceValue})</span>
                                )}
                                {belowTotalMrp !== "" && (
                                  <span className="cartPriceBelow"> {belowTotalMrp}</span>
                                )}
                              </p>
                              {item?.isTag && (
                                <div className="cartTagSelect">
                                  <CreatableSelect
                                    value={{ label: item.tag, value: "" }}
                                    allowCreateWhileLoading={true}
                                    options={tagOptions}
                                    styles={colourStyles}
                                    placeholder="Add Tag"
                                    onCreateOption={(tag) =>
                                      createTag(tag, _index)
                                    }
                                    onChange={(selectedOption) =>
                                      handleTagChange(selectedOption, _index)
                                    }
                                  />
                                </div>
                              )}
                            </div>
                            <div className="cartProductQty">
                              <button
                                type="button"
                                className="cartQtyBtn"
                                onClick={() =>
                                  events.handleQuantity(
                                    Number(item?.quantity) - 1,
                                    item?.sku_code,
                                    item?.product_name
                                  )
                                }
                              >
                                <img src={RemoveIcon} alt="-" />
                              </button>
                              <span className="cartQtyValue">{item?.quantity}</span>
                              <button
                                type="button"
                                className="cartQtyBtn"
                                onClick={() =>
                                  events.handleQuantity(
                                    Number(item?.quantity) + 1,
                                    item?.sku_code
                                  )
                                }
                              >
                                <img src={AddIcon} alt="+" />
                              </button>
                            </div>
                          </div>

                          {item?.MandatoryProducts?.length > 0 && (
                            <div className="cartMandatoryWrap">
                              <div
                                className="cartMandatoryHeader"
                                onClick={() =>
                                  toggleMandatoryAccordion(item.sku_code)
                                }
                              >
                                <span className="cartMandatoryTitle">
                                  {`Mandatory Products of ${item?.product_name} (${item.MandatoryProducts.length})`}
                                </span>
                                <span
                                  className={`cartMandatoryChevron ${expandedMandatory[item.sku_code] ? "open" : ""}`}
                                >
                                  {svgIcon("ico-arrowRight")}
                                </span>
                              </div>
                              {expandedMandatory[item.sku_code] && (
                                <div className="cartMandatoryList">
                                  {item.MandatoryProducts.map((mItem, mIndex) => {
                                    const mDesc =
                                      stripHtml(mItem?.product_description) || "";
                                    const isMDescLong = mDesc.length > 50;
                                    const isMExpanded = !!readMore[mItem?.sku_code];
                                    return (
                                      <div
                                        className="cartMandatoryItem"
                                        key={`m-${mIndex}`}
                                      >
                                        <div className="cartProductImage small">
                                          <img
                                            src={
                                              mItem?.product_image ||
                                              productPlaceholder
                                            }
                                            onError={(e) => {
                                              e.target.src = productPlaceholder;
                                            }}
                                            alt={mItem?.product_name || "..."}
                                          />
                                        </div>
                                        <div className="cartProductInfo">
                                          <h4 className="cartProductName">
                                            {mItem?.product_name}
                                          </h4>
                                          <p className="cartProductSku">
                                            {mItem?.sku_code}
                                          </p>
                                          <p className="cartProductSku">
                                            Quantity : {mItem?.quantity}
                                          </p>
                                          {mDesc && (
                                            <p className="cartProductDesc">
                                              {isMDescLong && !isMExpanded ? (
                                                <>
                                                  {`${mDesc.slice(0, 50)}... `}
                                                  <b
                                                    className="cursorPointer cartReadMore"
                                                    onClick={() =>
                                                      handleReadMore(
                                                        mItem?.sku_code
                                                      )
                                                    }
                                                  >
                                                    Read more
                                                  </b>
                                                </>
                                              ) : isMDescLong ? (
                                                <>
                                                  <span
                                                    dangerouslySetInnerHTML={{
                                                      __html: DOMPurify.sanitize(
                                                        mItem?.product_description
                                                      ),
                                                    }}
                                                  />
                                                  <b
                                                    className="cursorPointer cartReadMore"
                                                    onClick={() =>
                                                      handleReadMore(
                                                        mItem?.sku_code
                                                      )
                                                    }
                                                  >
                                                    {" "}Read less
                                                  </b>
                                                </>
                                              ) : (
                                                mDesc
                                              )}
                                            </p>
                                          )}
                                        </div>
                                        <div className="cartMandatoryPrice">
                                          <span className="cartMandatoryAmount">
                                            &#8377;{formatPrice((mItem?.quantity || 0) * (mItem?.product_price || 0))}
                                          </span>
                                          <span className="cartMandatorySuffix">
                                            /piece
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                      </React.Fragment>
                    );
                  })}
                </div>

                {/* Legacy desktop table (hidden) */}
                <div className="cart-table displayNoneMobile" style={{ display: "none" }}>
                  <table cellPadding="10">
                    <thead>
                      <tr>
                        {/* {
                                            tableHeader.map((th, i) => (
                                                <th key={i} style={{ textAlign: 'center' }}>{th.text}</th>
                                            ))
                                        } */}
                        <th
                          style={{
                            textAlign: "center",
                            width: cartData[0]?.isTag ? "11%" : "15%",
                          }}
                        >
                          Image
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            width: cartData[0]?.isTag ? "13%" : "15%",
                          }}
                        >
                          Product Name
                        </th>
                        {cartData[0]?.isTag && (
                          <th style={{ textAlign: "center", width: "14%" }}>
                            Tag
                          </th>
                        )}
                        <th
                          style={{
                            textAlign: "center",
                            width: cartData[0]?.isTag ? "11%" : "14%",
                          }}
                        >
                          Sku Code
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            width: cartData[0]?.isTag ? "27%" : "28%",
                          }}
                        >
                          Product Description
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            width: cartData[0]?.isTag ? "8%" : "11%",
                          }}
                        >
                          Qty
                        </th>
                        <th
                          style={{
                            textAlign: "center",
                            width: cartData[0]?.isTag ? "16%" : "17%",
                          }}
                        >
                          {priceValue}
                          {belowTotalMrp !== "" && (
                            <p className="bellowTextTotalMrp">
                              {belowTotalMrp}
                            </p>
                          )}
                        </th>
                        {/* <th style={{ textAlign: 'center', width: cartData[0]?.isTag ? '4%' : '5%' }}></th> */}
                      </tr>
                    </thead>

                    <tbody>
                      {cartData &&
                        cartData.map((item, _index) => {
                          const text = stripHtml(item?.product_description);
                          return (
                            <>
                              {/* <ProductItem itemData={item} key={_index} events={events} /> */}
                              <React.Fragment key={_index}>
                                <tr>
                                  <td>
                                    <div className="MandatoryAccordian">
                                      <div>
                                        {item?.MandatoryProducts?.length > 0 && (
                                          <div
                                            className="mandatoryAccordionBtn"
                                            onClick={() => toggleMandatoryAccordion(item.sku_code)}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                transform: expandedMandatory[item.sku_code]
                                                  ? "rotate(90deg)"
                                                  : "rotate(0deg)",
                                                transition: "transform 0.3s ease",
                                                cursor: "pointer"
                                              }}
                                            >
                                              {svgIcon("ico-arrowRight")}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                      <div>
                                        <img
                                          src={item.product_image || productPlaceholder}
                                          onError={(e) => {
                                            e.target.src = productPlaceholder
                                          }}
                                          alt={item.product_name}
                                        />
                                      </div>

                                    </div>

                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    {item.product_name}
                                  </td>

                                  {item?.isTag && (
                                    <td>
                                      <CreatableSelect
                                        value={{ label: item.tag, value: "" }}
                                        allowCreateWhileLoading={true}
                                        options={tagOptions}
                                        styles={colourStyles}
                                        onCreateOption={(tag) =>
                                          createTag(tag, _index)
                                        }
                                        onChange={(selectedOption) =>
                                          handleTagChange(selectedOption, _index)
                                        }
                                      />
                                    </td>
                                  )}

                                  <td style={{ textAlign: "center" }}>
                                    <p>{item.sku_code}</p>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <>
                                      {!readMore[item?.sku_code] ? (
                                        <p>
                                          {stripHtml(item?.product_description)?.slice(0, 50)}...
                                          <b
                                            className="cursorPointer"
                                            onClick={() =>
                                              handleReadMore(item?.sku_code)
                                            }
                                          >
                                            Read more
                                          </b>
                                        </p>
                                      ) : (
                                        <p>
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: DOMPurify.sanitize(
                                                item?.product_description
                                              ),
                                            }}
                                          />
                                          <b
                                            className="cursorPointer"
                                            onClick={() =>
                                              handleReadMore(item?.sku_code)
                                            }
                                          >
                                            Read less
                                          </b>
                                        </p>
                                      )}
                                    </>
                                  </td>

                                  <td>
                                    <div className="productQuantityMain">
                                      <div className="cartRemoveImgDiv">
                                        <img
                                          src={RemoveIcon}
                                          alt="-"
                                          className="minusFont"
                                          onClick={() =>
                                            events.handleQuantity(
                                              Number(item?.quantity) - 1,
                                              item?.sku_code,
                                              item?.product_name
                                            )
                                          }
                                        />
                                      </div>

                                      <p>{item?.quantity}</p>

                                      <div className="cartRemoveImgDiv">
                                        <img
                                          src={AddIcon}
                                          alt="+"
                                          onClick={() =>
                                            events.handleQuantity(
                                              Number(item?.quantity) + 1,
                                              item?.sku_code
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <b className="price">
                                      &#8377; {formatPrice(item.quantity * item.product_price)}
                                    </b>
                                  </td>
                                </tr>

                                {expandedMandatory[item.sku_code] &&
                                  item?.MandatoryProducts?.length > 0 && (
                                    item.MandatoryProducts.map((mItem, mIndex) => (
                                      <tr>
                                        <td>
                                          <div className="MandatoryAccordian">
                                            <div>

                                              <div
                                                className="mandatoryAccordionBtn"
                                                style={{ visibility: mItem?.MandatoryProducts?.length > 0 ? "visible" : "hidden" }}
                                                onClick={() => toggleMandatoryAccordion(mItem.sku_code)}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    transform: expandedMandatory[mItem.sku_code]
                                                      ? "rotate(90deg)"
                                                      : "rotate(0deg)",
                                                    transition: "transform 0.3s ease",
                                                    cursor: "pointer"
                                                  }}
                                                >
                                                  {svgIcon("ico-arrowRight")}
                                                </span>
                                              </div>

                                            </div>
                                            <div>
                                              <img
                                                src={mItem.product_image || productPlaceholder}
                                                onError={(e) => {
                                                  e.target.src = productPlaceholder
                                                }}
                                                alt={mItem.product_name}
                                              />
                                            </div>

                                          </div>

                                        </td>

                                        <td style={{ textAlign: "center" }}>
                                          {mItem.product_name}
                                        </td>

                                        {mItem?.isTag && (
                                          <td>
                                            <CreatableSelect
                                              value={{ label: mItem.tag, value: "" }}
                                              allowCreateWhileLoading={true}
                                              options={tagOptions}
                                              styles={colourStyles}
                                              onCreateOption={(tag) =>
                                                createTag(tag, _index)
                                              }
                                              onChange={(selectedOption) =>
                                                handleTagChange(selectedOption, _index)
                                              }
                                            />
                                          </td>
                                        )}

                                        <td style={{ textAlign: "center" }}>
                                          <p>{mItem.sku_code}</p>
                                        </td>

                                        <td style={{ textAlign: "center" }}>
                                          <>
                                            {!readMore[mItem?.sku_code] ? (
                                              <p>
                                                {stripHtml(mItem?.product_description)?.slice(0, 50)}...
                                                <b
                                                  className="cursorPointer"
                                                  onClick={() =>
                                                    handleReadMore(mItem?.sku_code)
                                                  }
                                                >
                                                  Read more
                                                </b>
                                              </p>
                                            ) : (
                                              <p>
                                                <span
                                                  dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                      mItem?.product_description
                                                    ),
                                                  }}
                                                />
                                                <b
                                                  className="cursorPointer"
                                                  onClick={() =>
                                                    handleReadMore(mItem?.sku_code)
                                                  }
                                                >
                                                  Read less
                                                </b>
                                              </p>
                                            )}
                                          </>
                                        </td>

                                        <td>
                                          <div className="productQuantityMain"
                                            style={{ opacity: 0.5 }}
                                          >
                                            <div className="cartRemoveImgDiv"
                                            >
                                              <img
                                                src={RemoveIcon}
                                                alt="-"
                                                className="minusFont"
                                              // onClick={() => {
                                              //   events.handleQuantity(
                                              //     Number(mItem?.quantity) - 1,
                                              //     mItem?.sku_code,
                                              //     mItem?.product_name,
                                              //     true,
                                              //     mItem.parentID
                                              //   )
                                              // }}
                                              />
                                            </div>

                                            <p>{mItem?.quantity}</p>

                                            <div className="cartRemoveImgDiv">
                                              <img
                                                src={AddIcon}
                                                alt="+"
                                              // onClick={() =>
                                              //   events.handleQuantity(
                                              //     Number(mItem?.quantity) + 1,
                                              //     mItem?.sku_code,
                                              //     true,
                                              //     mItem.parentID
                                              //   )
                                              // }
                                              />
                                            </div>
                                          </div>
                                        </td>

                                        <td style={{ textAlign: "center" }}>
                                          <b className="price">
                                            &#8377; {formatPrice(mItem.quantity * mItem.product_price)}
                                          </b>
                                        </td>
                                      </tr>
                                    ))
                                  )}
                              </React.Fragment>
                            </>
                          )
                        })}
                    </tbody>
                  </table>
                </div>
                {/* Desktop cart start */}

                {/* Legacy mobile cart (hidden) */}
                <div className="mobileCartsection" style={{ display: "none" }}>
                  {cartData?.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        {/* Parent Product */}
                        <div className="mobilecartMain">
                          <div className="productImageSec">
                            <div className="productImageCart">
                              <div className="MandatoryAccordian">
                                <div>
                                  {item?.MandatoryProducts?.length > 0 && (
                                    <div
                                      className="mandatoryAccordionBtn"
                                      onClick={() =>
                                        toggleMandatoryAccordion(item.sku_code)
                                      }
                                    >
                                      <span
                                        style={{
                                          display: "inline-block",
                                          transform: expandedMandatory[item.sku_code]
                                            ? "rotate(90deg)"
                                            : "rotate(0deg)",
                                          transition: "transform 0.3s ease",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {svgIcon("ico-arrowRight")}
                                      </span>
                                    </div>
                                  )}
                                </div>

                                <div>
                                  <img
                                    src={
                                      item?.product_image ||
                                      productPlaceholder
                                    }
                                    onError={(e) => {
                                      e.target.src = productPlaceholder
                                    }}
                                    alt={
                                      item?.product_name || "..."
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="productDetailsSec">
                            <div className="productDetailsCartMain">
                              <div className="productNameCross">
                                <div className="productName">
                                  <h3>{item?.product_name}</h3>

                                  <h5>{`(${item?.sku_code})`}</h5>

                                  <>
                                    {item?.product_description?.length >
                                      50 ? (
                                      <>
                                        {!readMore[item?.sku_code] ? (
                                          <p>
                                            {`${item?.product_description?.slice(
                                              0,
                                              50
                                            )}...`}

                                            <b
                                              className="cursorPointer"
                                              onClick={() =>
                                                handleReadMore(
                                                  item?.sku_code
                                                )
                                              }
                                            >
                                              Read more
                                            </b>
                                          </p>
                                        ) : (
                                          <p>
                                            {`${item?.product_description?.slice(
                                              0,
                                              200
                                            )} `}

                                            <b
                                              className="cursorPointer"
                                              onClick={() =>
                                                handleReadMore(
                                                  item?.sku_code
                                                )
                                              }
                                            >
                                              Read less
                                            </b>
                                          </p>
                                        )}
                                      </>
                                    ) : (
                                      <p>
                                        {item.product_description}
                                      </p>
                                    )}
                                  </>

                                  {cartData[0]?.isTag && (
                                    <div className="addTagMobile">
                                      <CreatableSelect
                                        value={{
                                          label: item.tag,
                                          value: "",
                                        }}
                                        allowCreateWhileLoading={
                                          true
                                        }
                                        options={tagOptions}
                                        styles={colourStyles}
                                        placeholder="Add Tag"
                                        onCreateOption={(tag) =>
                                          createTag(tag, index)
                                        }
                                        onChange={(
                                          selectedOption
                                        ) =>
                                          handleTagChange(
                                            selectedOption,
                                            index
                                          )
                                        }
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="productPriceandQuantity">
                                <div className="productPriceCart">
                                  <h3 className="marginBottom0">
                                    {`Rs. ${formatPrice(
                                      item?.quantity * item?.product_price
                                    )}`}
                                  </h3>

                                  <span>({priceValue})</span>

                                  <br />

                                  {belowTotalMrp !== "" && (
                                    <span>{belowTotalMrp}</span>
                                  )}
                                </div>

                                <div className="productQuantity">
                                  <div className="productQuantityMain">
                                    <p
                                      className="minusFont"
                                      onClick={() =>
                                        events.handleQuantity(
                                          Number(item?.quantity) -
                                          1,
                                          item?.sku_code,
                                          item?.product_name
                                        )
                                      }
                                    >
                                      <img
                                        src={RemoveIcon}
                                        alt="-"
                                      />
                                    </p>

                                    <p>{item?.quantity}</p>

                                    <p
                                      onClick={() =>
                                        events.handleQuantity(
                                          Number(item?.quantity) +
                                          1,
                                          item?.sku_code
                                        )
                                      }
                                    >
                                      <img
                                        src={AddIcon}
                                        alt="-"
                                      />
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Mandatory Products */}
                        {expandedMandatory[item.sku_code] &&
                          item?.MandatoryProducts?.length >
                          0 &&
                          item.MandatoryProducts.map(
                            (mItem, mIndex) => (
                              <div
                                key={mIndex}
                                className="mobilecartMain mandatoryMobileCard"
                              >
                                <div className="productImageSec">
                                  <div className="productImageCart">
                                    <div className="MandatoryAccordian">
                                      <div>
                                        <div
                                          className="mandatoryAccordionBtn"
                                          style={{
                                            visibility:
                                              mItem?.MandatoryProducts
                                                ?.length > 0
                                                ? "visible"
                                                : "hidden",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display:
                                                "inline-block",
                                              opacity: 0,
                                            }}
                                          >
                                            {
                                              svgIcon(
                                                "ico-arrowRight"
                                              )
                                            }
                                          </span>
                                        </div>
                                      </div>

                                      <div>
                                        <img
                                          src={
                                            mItem?.product_image ||
                                            productPlaceholder
                                          }
                                          onError={(e) => {
                                            e.target.src = productPlaceholder
                                          }}
                                          alt={
                                            mItem?.product_name
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="productDetailsSec">
                                  <div className="productDetailsCartMain">
                                    <div className="productNameCross">
                                      <div className="productName">
                                        <h3>
                                          {mItem?.product_name}
                                        </h3>

                                        <h5>
                                          ({mItem?.sku_code})
                                        </h5>

                                        <>
                                          {mItem?.product_description
                                            ?.length > 50 ? (
                                            <>
                                              {!readMore[
                                                mItem?.sku_code
                                              ] ? (
                                                <p>
                                                  {`${mItem?.product_description?.slice(
                                                    0,
                                                    50
                                                  )}...`}

                                                  <b
                                                    className="cursorPointer"
                                                    onClick={() =>
                                                      handleReadMore(
                                                        mItem?.sku_code
                                                      )
                                                    }
                                                  >
                                                    Read more
                                                  </b>
                                                </p>
                                              ) : (
                                                <p>
                                                  {`${mItem?.product_description?.slice(
                                                    0,
                                                    200
                                                  )} `}

                                                  <b
                                                    className="cursorPointer"
                                                    onClick={() =>
                                                      handleReadMore(
                                                        mItem?.sku_code
                                                      )
                                                    }
                                                  >
                                                    Read less
                                                  </b>
                                                </p>
                                              )}
                                            </>
                                          ) : (
                                            <p>
                                              {
                                                mItem.product_description
                                              }
                                            </p>
                                          )}
                                        </>
                                      </div>
                                    </div>

                                    <div className="productPriceandQuantity">
                                      <div className="productPriceCart">
                                        <h3 className="marginBottom0">
                                          {`Rs. ${formatPrice(
                                            mItem?.quantity * mItem?.product_price
                                          )}`}
                                        </h3>

                                        <span>
                                          ({priceValue})
                                        </span>

                                        <br />

                                        {belowTotalMrp !== "" && (
                                          <span>
                                            {belowTotalMrp}
                                          </span>
                                        )}
                                      </div>

                                      <div className="productQuantity">
                                        <div
                                          className="productQuantityMain"
                                          style={{ opacity: 0.5 }}
                                        >
                                          <p className="minusFont">
                                            <img
                                              src={RemoveIcon}
                                              alt="-"
                                            />
                                          </p>

                                          <p>
                                            {mItem?.quantity}
                                          </p>

                                          <p>
                                            <img
                                              src={AddIcon}
                                              alt="-"
                                            />
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                      </React.Fragment>
                    );
                  })}
                </div>
                {/* mobile Cart end */}
                <div className="cartData-action">
                  <button
                    type="button"
                    className="btn"
                    children="Download Pdf"
                    onClick={printHanler}
                  />
                  {isExcel === "true" && (
                    <button
                      type="button"
                      className="btn"
                      children="Download Excel"
                      onClick={printExcelHanler}
                    />
                  )}
                  <button
                    type="button"
                    className="btn ClearCartBtn"
                    children="Clear Cart"
                    onClick={() => setIsClearConfirmationModalOpen(true)}
                  />
                  {/* <button type="button" className="btn" children="Email" /> */}
                </div>
              </React.Fragment>
            ) : (
              <p className="empty-cart-text">Your Cart is Empty</p>
            )}
          </>
        )}
      </div>

      {isClearConfirmationModalOpen && (
        <>
          <div className="modal confirmationModal">
            <span className="cross" onClick={CloseConfirmModal} />
            <div className="confirmationBody">
              <p>
                All cart items and tags will get cleared. Are you sure you want
                to go ahead ?
              </p>
              <div className="confirmationActionBtnMain">
                <div className="confirmationActionBtn">
                  <button
                    type="button"
                    className="btn ClearCartBtn"
                    children="Cancel"
                    onClick={CloseConfirmModal}
                  />
                  <button
                    type="button"
                    className="btn ClearCartBtn"
                    children="Clear"
                    onClick={handleClearCart}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={CloseConfirmModal}
            className={`modal-backdrop CloseConfirmModal ${isClearConfirmationModalOpen ? "show" : "fade"
              }`}
          ></div>
        </>
      )}
    </React.Fragment>
  );
};

export default ProductDrawer;

const ProductItem = ({ itemData, events }) => {
  return (
    // <div className="cart-item">
    //     <h2>{itemData.product_name}
    //         <span className="clear-item" children={svgIcon('ico-trash')} onClick={() => events.handleDelete(itemData.sku_code)} />
    //     </h2>
    //     <div className="row">
    //         <div className="column item-img">
    //             <img src={itemData.product_image} alt={itemData.product_name} />
    //         </div>
    //         <div className="column item-desc">
    //             <p><b>{itemData.sku_code}</b></p>
    //             <p>{itemData.product_description}</p>
    //             <p key={itemData.quantity}>
    //                 <input
    //                     type="number"
    //                     defaultValue={itemData.quantity || 1}
    //                     className="item-quanity"
    //                     min={1}
    //                     onChange={({ currentTarget }) => events.handleQuantity(currentTarget.value, itemData.sku_code)}
    //                 />
    //                 <b className="price">&#8377; {itemData.product_price}</b>
    //             </p>
    //         </div>
    //         <div className="clearfix" />
    //     </div>
    // </div>

    <React.Fragment>
      <tr>
        <td>
          <img
            src={itemData.product_image || productPlaceholder}
            alt={itemData.product_name}
            onError={(e) => {
              e.target.src = productPlaceholder
            }}
          />
        </td>

        <td style={{ textAlign: "center" }}>{itemData.product_name}</td>
        <td>
          <input type="text" className="item-quanity" name="tagName" />
        </td>
        <td style={{ textAlign: "center" }}>
          <b>{itemData.sku_code}</b>
        </td>
        <td style={{ textAlign: "center" }}>
          {/* <b> {itemData.sku_code} </b> */}
          <p> {itemData.product_description} </p>
        </td>

        <td>
          <p key={itemData.quantity}>
            <input
              type="number"
              // defaultValue={itemData.quantity || 1}
              value={itemData.quantity}
              className="item-quanity"
              min={1}
              onChange={({ currentTarget }) =>
                events.handleQuantity(currentTarget.value, itemData.sku_code)
              }
            />
          </p>
        </td>

        <td style={{ textAlign: "center" }}>
          <b className="price">
            &#8377; {formatPrice(itemData.quantity * itemData.product_price)}
          </b>
        </td>

        <td style={{ textAlign: "center", cursor: "pointer" }}>
          <span
            className="clear-item"
            children={svgIcon("ico-trash")}
            onClick={() =>
              events.handleDelete(itemData.sku_code, itemData.product_name)
            }
          />
        </td>
      </tr>
    </React.Fragment>
  );
};
